import { Chapter, CreateChapterDto } from '../../../interfaces/chapters.interface';
import { Question } from '../../../interfaces/questions.interface';
import { DropdownChangeParams } from 'primereact/dropdown';

export interface ChapterFormProps {
  mode: 'create' | 'edit';
  initialChapter?: Chapter;
  onSubmitSuccess: () => void;
}

export interface BaseStepProps {
  values: CreateChapterDto;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | DropdownChangeParams) => void;
  errors?: Record<string, string>;
  touched?: Record<string, boolean>;
}

export interface StepOneProps extends BaseStepProps {}

export interface StepTwoProps extends BaseStepProps {
  onQuestionAdded: (question: Omit<Question, '_id' | 'chapter'>) => void;
  onQuestionEdited: (index: number, question: Omit<Question, '_id' | 'chapter'>) => void;
  onRemoveQuestion: (index: number) => void;
}

export interface StepThreeProps extends BaseStepProps {}

export interface QuestionsSectionProps {
  category: string;
  onQuestionAdded?: (question: Omit<Question, '_id' | 'chapter'>) => void;
  editingQuestion?: Omit<Question, '_id' | 'chapter'>;
  onQuestionEdited?: (question: Omit<Question, '_id' | 'chapter'>) => void;
}

export interface AddedQuestionsSectionProps {
  questions: Omit<Question, '_id' | 'chapter'>[];
  onRemoveQuestion: (index: number) => void;
  onEditQuestion: (index: number) => void;
}

export const commonStyles = {
  inputClassName: "mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary",
  labelClassName: "block text-sm font-medium text-gray-700",
  errorClassName: "text-red-600 text-sm",
};
